import { cn } from '@/lib/cn';
import { clamp } from '@/lib/format';

interface ProgressBarProps {
  value: number;
  max: number;
  className?: string;
  color?: string;
  showLabel?: boolean;
  labelPrefix?: string;
  labelClassName?: string;
}

export function ProgressBar({
  value,
  max,
  className,
  color = 'bg-accent',
  showLabel,
  labelPrefix,
  labelClassName,
}: ProgressBarProps) {
  const pct = max > 0 ? clamp((value / max) * 100, 0, 100) : 0;
  return (
    <div className={cn('relative w-full h-3 rounded-full bg-bg-elevated overflow-hidden', className)}>
      <div
        className={cn('h-full transition-all duration-500', color)}
        style={{ width: `${pct}%` }}
      />
      {showLabel && (
        <div
          className={cn(
            'absolute inset-0 flex items-center justify-center text-[11px] font-medium tabular-nums',
            labelClassName ?? 'text-white',
          )}
        >
          {labelPrefix}
          {Math.floor(value)} / {max}
        </div>
      )}
    </div>
  );
}
